/* KOR-E Mobile Sticky Add to Cart — Floating Product Card */
(function () {
  'use strict';

  var MOBILE_BP = 750;

  function KoreStickyATC(bar) {
    var sectionId = bar.dataset.sectionId;
    if (!sectionId) return;

    var stickyBtn   = document.getElementById('KoreStickyATCBtn-'   + sectionId);
    var stickyImg   = document.getElementById('KoreStickyATCImg-'   + sectionId);
    var stickyPrice = document.getElementById('KoreStickyATCPrice-' + sectionId);
    var scrollBtn   = bar.querySelector('.kore-satc__scroll-btn');
    if (!stickyBtn) return;

    var realBtnId  = stickyBtn.dataset.realBtn;
    var realFormId = stickyBtn.dataset.realForm;
    var realBtn    = realBtnId  ? document.getElementById(realBtnId)  : null;
    var realForm   = realFormId ? document.getElementById(realFormId) : null;
    if (!realBtn || !realForm) return;

    var sentinel     = realBtn.closest('.product-form__buttons') || realBtn;
    var isBarVisible = false;
    var isMobile     = window.innerWidth < MOBILE_BP;
    var io           = null;
    var mutObs       = null;
    var priceObs     = null;
    var clickLocked  = false;

    /* ── Variant → image map ─────────────────────────────────────────────── */
    var variantMap = {};
    var productImg = null;
    (function loadData() {
      var el = document.getElementById('KoreStickyATCData-' + sectionId);
      if (!el) return;
      try {
        var d = JSON.parse(el.textContent);
        productImg = d.product_img || null;
        (d.variants || []).forEach(function (v) { variantMap[v.id] = v.img || null; });
      } catch (e) {}
    }());

    /* ── Button-state sync ───────────────────────────────────────────────── */
    function syncState() {
      var disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = disabled;
      if (disabled) stickyBtn.setAttribute('aria-disabled', 'true');
      else          stickyBtn.removeAttribute('aria-disabled');
      var realSpan   = realBtn.querySelector('span:not(.loading__spinner):not(.loading-overlay__spinner)');
      var stickySpan = stickyBtn.querySelector('.kore-satc__btn-text');
      if (realSpan && stickySpan) {
        var txt = realSpan.textContent.trim();
        if (txt) stickySpan.textContent = txt;
      }
    }

    /* ── Price sync (reads from live DOM price element) ──────────────────── */
    function syncPrice() {
      if (!stickyPrice) return;
      var pc = document.getElementById('price-' + sectionId);
      if (!pc) return;
      var priceEl;
      var saleSection = pc.querySelector('.price__sale');
      if (saleSection && !saleSection.classList.contains('price__sale--hidden')) {
        priceEl = saleSection.querySelector('.price-item--sale');
      }
      if (!priceEl) priceEl = pc.querySelector('.price__regular .price-item--regular');
      if (!priceEl) priceEl = pc.querySelector('.price-item--regular, .price-item--sale');
      if (priceEl) {
        var txt = priceEl.textContent.trim();
        if (txt && txt !== stickyPrice.textContent.trim()) stickyPrice.textContent = txt;
      }
    }

    /* ── Image sync (looks up variant in the inline JSON map) ────────────── */
    function syncImage(variantId) {
      if (!stickyImg) return;
      var vid = parseInt(variantId, 10);
      var imgSrc = variantMap.hasOwnProperty(vid) ? variantMap[vid] : null;
      if (!imgSrc) imgSrc = productImg;
      if (imgSrc) stickyImg.src = imgSrc;
    }

    /* ── Show / hide ─────────────────────────────────────────────────────── */
    function showBar() {
      if (isBarVisible || !isMobile) return;
      isBarVisible = true;
      bar.classList.add('kore-satc--visible');
      bar.removeAttribute('aria-hidden');
      syncState();
      syncPrice();
    }
    function hideBar() {
      if (!isBarVisible) return;
      isBarVisible = false;
      bar.classList.remove('kore-satc--visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    /* ── IntersectionObserver ────────────────────────────────────────────── */
    function setupObserver() {
      if (io) { io.disconnect(); io = null; }
      if (!isMobile) { hideBar(); return; }
      io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          hideBar();
        } else if (entry.boundingClientRect.bottom < 0) {
          showBar();
        } else {
          hideBar();
        }
      }, { threshold: 0.0, rootMargin: '0px' });
      io.observe(sentinel);
    }

    /* ── ATC button click ────────────────────────────────────────────────── */
    function onStickyClick() {
      if (clickLocked) return;
      if (stickyBtn.disabled || stickyBtn.getAttribute('aria-disabled') === 'true') return;
      clickLocked = true;
      stickyBtn.classList.add('kore-satc__btn--loading');
      stickyBtn.setAttribute('aria-busy', 'true');
      if (realBtn && !realBtn.disabled) {
        realBtn.click();
      } else if (typeof realForm.requestSubmit === 'function') {
        realForm.requestSubmit();
      } else {
        realForm.submit();
      }
      setTimeout(function () {
        clickLocked = false;
        stickyBtn.classList.remove('kore-satc__btn--loading');
        stickyBtn.removeAttribute('aria-busy');
        syncState();
      }, 1400);
    }
    stickyBtn.addEventListener('click', onStickyClick);

    /* ── Scroll-to-product click (image / name / price area) ─────────────── */
    function onScrollBtnClick() {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      sentinel.scrollIntoView({
        behavior: prefersReduced ? 'auto' : 'smooth',
        block: 'center'
      });
    }
    if (scrollBtn) scrollBtn.addEventListener('click', onScrollBtnClick);

    /* ── MutationObserver: real button state ─────────────────────────────── */
    mutObs = new MutationObserver(syncState);
    mutObs.observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'],
      childList: true,
      subtree: true
    });

    /* ── MutationObserver: price container ───────────────────────────────── */
    (function setupPriceObs() {
      var pc = document.getElementById('price-' + sectionId);
      if (!pc) return;
      priceObs = new MutationObserver(syncPrice);
      priceObs.observe(pc, { childList: true, subtree: true, characterData: true });
    }());

    /* ── Variant input change → image sync ───────────────────────────────── */
    var varInput = realForm.querySelector('[name="id"]');
    if (varInput) {
      varInput.addEventListener('change', function () { syncImage(this.value); });
      syncImage(varInput.value);
    }

    /* ── Resize ──────────────────────────────────────────────────────────── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = window.innerWidth < MOBILE_BP;
        if (nowMobile !== isMobile) { isMobile = nowMobile; hideBar(); setupObserver(); }
      }, 150);
    });

    /* ── Theme Editor cleanup ────────────────────────────────────────────── */
    function cleanup() {
      if (io)       { io.disconnect();       io       = null; }
      if (mutObs)   { mutObs.disconnect();   mutObs   = null; }
      if (priceObs) { priceObs.disconnect(); priceObs = null; }
      stickyBtn.removeEventListener('click', onStickyClick);
      if (scrollBtn) scrollBtn.removeEventListener('click', onScrollBtnClick);
      hideBar();
      bar._koreATCInit = false;
    }
    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.detail && evt.detail.sectionId === sectionId) cleanup();
    });

    /* ── Init ────────────────────────────────────────────────────────────── */
    syncState();
    syncPrice();
    setupObserver();
  }

  /* ── Boot ────────────────────────────────────────────────────────────────── */
  function initAll() {
    document.querySelectorAll('.kore-satc[data-section-id]').forEach(function (bar) {
      if (bar._koreATCInit) return;
      bar._koreATCInit = true;
      KoreStickyATC(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(initAll, 0); });

}());
